import React from "react";
import ReactDOM from 'react-dom'; // React 17 way
import 'assets/css/black-dashboard-react.css'; // Import the CSS file
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import RTLLayout from "layouts/RTL/RTL.js";

import "assets/scss/black-dashboard-react.scss";
import "assets/demo/demo.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import LoginPage from './newViews/Login/login';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Target container is not a DOM element');
}

ReactDOM.render(
  <ThemeContextWrapper>
    <BackgroundColorWrapper>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/rtl/*" element={<RTLLayout />} />
          <Route path="*" element={localStorage.getItem('token') ?
            <Navigate to="/rtl/dashboard" replace /> : <Navigate to="/login" replace />}/>
        </Routes>
      </BrowserRouter>
    </BackgroundColorWrapper>
  </ThemeContextWrapper>,
  rootElement
);
